/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Samplecta1Inputs */

const ja_playdata_about_samplecta1 = /** @type {(inputs: Playdata_About_Samplecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポートを見る`)
};

const en_playdata_about_samplecta1 = /** @type {(inputs: Playdata_About_Samplecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download sample`)
};

/**
* | output |
* | --- |
* | "Download sample" |
*
* @param {Playdata_About_Samplecta1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_about_samplecta1 = /** @type {((inputs?: Playdata_About_Samplecta1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Samplecta1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_samplecta1(inputs)
	return en_playdata_about_samplecta1(inputs)
});
export { playdata_about_samplecta1 as "playdata_about_sampleCta" }